/* InventoryLastUpdated.module.css */
.container {
    display: flex;
    align-items: center;
}
  
.box {}

.text {
    font-size: var(----fs-small-heading); /* text-lg equivalent */
    color: var(--static-text-strong);
    font-weight: 400;

}

.boldText {
    font-weight: 600;
    color: var(--static-text-strong);
}